import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ActivateGuard } from '../shared/guards/activate.guard';
import { AuthGuard } from '../shared/guards/auth.guard';
import { CanAddPayersGuard } from '../shared/guards/can-add-payers.guard';
import { ReferidosGuard } from '../shared/guards/referidos.guard';
import { ClientGuard } from '../shared/guards/client.guard';
import { DataUpdateBlockGuard } from '../shared/guards/data-update-block.guard';
import { OperatorGuard } from '../shared/guards/operator.guard';
import { OverdraftGuard } from '../shared/guards/overdraft.guard';
import { AccountsComponent } from './components/accounts/accounts.component';
import { AdminTransactionsComponent } from './components/admin-transactions/admin-transactions.component';
import { AdminWalletsComponent } from './components/admin-wallets/admin-wallets.component';
import { AdminWhatsappOtpComponent } from './components/admin-whatsapp-otp/admin-whatsapp-otp.component';
import { AdminWithdrawalsUsdtComponent } from './components/admin-withdrawals-usdt/admin-withdrawals-usdt.component';
import { AssignedTransactionsCriptoComponent } from './components/assigned-transactions-cripto/assigned-transactions-cripto.component';
import { AssignedTransactionsComponent } from './components/assigned-transactions/assigned-transactions.component';
import { RejectTransactionModalComponent } from './components/assigned-transactions/reject-transaction-modal/reject-transaction-modal.component';
import { BalanceCajeroComponent } from './components/balance-cajero/balance-cajero.component';
import { BeneficiaryBookComponent } from './components/beneficiary-book/beneficiary-book.component';
import { BillingRecordComponent } from './components/billing-record/billing-record.component';
import { BinanceSearchByWalletComponent } from './components/binance-search-by-wallet/binance-search-by-wallet.component';
import { ValidarWalletComponent } from './components/validar-wallet/validar-wallet.component';
import { CalculatorCrytoComponent } from './components/calculator-cryto/calculator-cryto.component';
import { CalculatorZelleComponent } from './components/calculator-zelle/calculator-zelle.component';
import { CbpayCardexComponent } from './components/cbpay-cardex/cbpay-cardex.component';
import { CbpayViewWalletTransactionsComponent } from './components/cbpay-view-wallet-transactions/cbpay-view-wallet-transactions.component';
import { ChargeAccountComponent } from './components/charge-account/charge-account.component';
import { ComisionesBancariasComponent } from './components/comisiones-bancarias/comisiones-bancarias.component';
import { CompanyRegistrationComponent } from './components/company-registration/company-registration.component';
import { ComplianceListComponent } from './components/compliance-list/compliance-list.component';
import { ComplianceUserComponent } from './components/compliance-user/compliance-user.component';
import { ConvertUsdtClpComponent } from './components/convert-usdt-clp/convert-usdt-clp.component';
import { ConvertUsdtVesComponent } from './components/convert-usdt-ves/convert-usdt-ves.component';
import { ComprarBolivaresComponent } from './components/comprar-bolivares/comprar-bolivares.component';
import { ConvertVesUsdtComponent } from './components/convert-ves-usdt/convert-ves-usdt.component';
import { CriptoHomeComponent } from './components/cripto-home/cripto-home.component';
import { CriptoRateComponent } from './components/cripto-rate/cripto-rate.component';
import { DataUpdateRequestComponent } from './components/data-update-request/data-update-request.component';
import { BulkCreateDataUpdateRequestComponent } from './components/data-update-requests-admin/bulk-create-data-update-request/bulk-create-data-update-request.component';
import { DataUpdateRequestDetailComponent } from './components/data-update-requests-admin/data-update-request-detail/data-update-request-detail.component';
import { DataUpdateRequestsListComponent } from './components/data-update-requests-admin/data-update-requests-list/data-update-requests-list.component';
import { DenounceAccessManagerComponent } from './components/denounces/denounce-access-manager/denounce-access-manager.component';
import { DenounceDetailComponent } from './components/denounces/denounce-detail/denounce-detail.component';
import { DenounceListComponent } from './components/denounces/denounce-list/denounce-list.component';
import { PlatformMessagesInboxComponent } from './components/platform-messages-inbox/platform-messages-inbox.component';
import { PlatformMessagesSendComponent } from './components/platform-messages-send/platform-messages-send.component';
import { RailColombiaComponent } from './components/rail-colombia/rail-colombia.component';
import { RailPeruComponent } from './components/rail-peru/rail-peru.component';
// import { RailColombiaCalculadoraComponent } from './components/rail-colombia-calculadora/rail-colombia-calculadora.component';
import { AgentChatComponent } from './components/agent-chat/agent-chat.component';
import { BancoPlazaHomeComponent } from './components/banco-plaza-home/banco-plaza-home.component';
import { BancosActivosVesComponent } from './components/bancos-activos-ves/bancos-activos-ves.component';
import { BinanceCentralizationsComponent } from './components/binance-centralizations/binance-centralizations.component';
import { BinanceLinkSubaccountsComponent } from './components/binance-link-subaccounts/binance-link-subaccounts.component';
import { BonosAdminComponent } from './components/bonos-admin/bonos-admin.component';
import { MarketingAdminComponent } from './components/marketing-admin/marketing-admin.component';
import { RecordatorioAdminComponent } from './components/recordatorio-admin/recordatorio-admin.component';
import { ClientesApiAdminComponent } from './components/clientes-api-admin/clientes-api-admin.component';
import { ApiClienteComponent } from './components/api-cliente/api-cliente.component';
import { BonosComponent } from './components/bonos/bonos.component';
import { ConnectedUsersComponent } from './components/connected-users/connected-users.component';
import { ConnectionAnalyticsComponent } from './components/connection-analytics/connection-analytics.component';
import { ConnectionHistoryComponent } from './components/connection-history/connection-history.component';
import { CuentasActivasVesComponent } from './components/cuentas-activas-ves/cuentas-activas-ves.component';
import { DetalleCajeroComponent } from './components/detalle-cajero/detalle-cajero.component';
import { GenerateCashClosingComponent } from './components/generate-rcash-closing/generate-cash-closing.component';
import { HoursOperationsComponent } from './components/hours-operations/hours-operations.component';
import { ListPaysWalletsOperatorComponent } from './components/list-pays-wallets-operator/list-pays-wallets-operator.component';
import { LoadPaysBinanceComponent } from './components/load-pays-binance/load-pays-binance.component';
import { ManualTransactionsComponent } from './components/manual-transactions/manual-transactions.component';
import { ManualXlsBciComponent } from './components/manual-xls-bci/manual-xls-bci.component';
import { MyConnectionsComponent } from './components/my-connections/my-connections.component';
import { N58HomeComponent } from './components/n58-home/n58-home.component';
import { CreatePayerComponent } from './components/payer/create-payer/create-payer.component';
import { ListPayerComponent } from './components/payer/list-payer/list-payer.component';
import { PayerComplianceListComponent } from './components/payer/payer-compliance-list/payer-compliance-list.component';
import { PayerInvitationsComponent } from './components/payer/payer-invitations/payer-invitations.component';
import { PendingTransactionsZelleComponent } from './components/pending-transactions-zelle/pending-transactions-zelle.component';
import { R4HomeComponent } from './components/r4-home/r4-home.component';
import { RecipientCriptoComponent } from './components/recipient-cripto/recipient-cripto.component';
import { RecipientZelleComponent } from './components/recipient-zelle/recipient-zelle.component';
import { ReferenciasVesAdminComponent } from './components/referencias-ves-admin/referencias-ves-admin.component';
import { ReferenciasVesComponent } from './components/referencias-ves/referencias-ves.component';
import { ReferidosAdminComponent } from './components/referidos-admin/referidos-admin.component';
import { ReferidosComponent } from './components/referidos/referidos.component';
import { RegistroBeneficiariosComponent } from './components/registro-beneficiarios/registro-beneficiarios.component';
import { RemittanceHubComponent } from './components/remittance-hub/remittance-hub.component';
import { ResponsableWalletComponent } from './components/responsable-wallet/responsable-wallet.component';
import { ReportUsdtClpGeneralComponent } from './components/report-usdt-clp-general/report-usdt-clp-general.component';
import { ReportUsdtVesGeneralComponent } from './components/report-usdt-ves-general/report-usdt-ves-general.component';
import { SeguimientoComponent } from './components/seguimiento/seguimiento.component';
import { SendUsdtComponent } from './components/send-usdt/send-usdt.component';
import { SetRatesParametersBolivaresComponent } from './components/set-rates-parameters-bolivares/set-rates-parameters-bolivares.component';
import { SetRatesParametersComponent } from './components/set-rates-parameters/set-rates-parameters.component';
import { SetRatesSalesParametersComponent } from './components/set-rates-sales-parameters/set-rates-sales-parameters.component';
import { StatusCajeroFiatComponent } from './components/status-cajero-fiat/status-cajero-fiat.component';
import { StatusCajeroComponent } from './components/status-cajero/status-cajero.component';
import { TransactionCashierComponent } from './components/transaction-cashier/transaction-cashier.component';
import { OperationsHistoryComponent } from './components/operations-history/operations-history.component';
import { ConciliacionAbonosComponent } from './components/conciliacion-abonos/conciliacion-abonos.component';
import { TransactionsDashboardComponent } from './components/transactions-dashboard/transactions-dashboard.component';
import { TransactionsVesCompletedComponent } from './components/transactions-ves-completed/transactions-ves-completed.component';
import { TransactionsVesComponent } from './components/transactions-ves/transactions-ves.component';
import { TransactionsComponent } from './components/transactions/transactions.component';
import { UnassignedTransactionsComponent } from './components/unassigned-transactions/unassigned-transactions.component';
import { UserHomeComponent } from './components/user-home/user-home.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { UserSegmentationComponent } from './components/user-segmentation/user-segmentation.component';
import { UsersBalanceSearchComponent } from './components/users-balance-search/users-balance-search.component';
import { UsersBalanceComponent } from './components/users-balance/users-balance.component';
import { VitaDashboardComponent } from './components/vita-dashboard/vita-dashboard.component';
import { VitaMovimientosComponent } from './components/vita-movimientos/vita-movimientos.component';
import { VitaRegistroComponent } from './components/vita-registro/vita-registro.component';
import { WalletsCardexConciliatorComponent } from './components/wallets-cardex-conciliator/wallets-cardex-conciliator.component';
import { WalletsUsuariosComponent } from './components/wallets-usuarios/wallets-usuarios.component';
import { WithdrawAccountsComponent } from './components/withdraw-accounts/withdraw-accounts.component';
import { WithdrawBalanceVesComponent } from './components/withdraw-balance-ves/withdraw-balance-ves.component';
import { WithdrawBalanceComponent } from './components/withdraw-balance/withdraw-balance.component';
import { WithdrawTrxListComponent } from './components/withdraw-trx-list/withdraw-trx-list.component';
import { WithdrawTrxSentComponent } from './components/withdraw-trx-sent/withdraw-trx-sent.component';
import { WorkingAccountComponent } from './components/working-account/working-account.component';
import { ZelleHomeComponent } from './components/zelle-home/zelle-home.component';
import { ZelleRateComponent } from './components/zelle-rate/zelle-rate.component';
import { HomeComponent } from './pages/home/home.component';
const routes: Routes = [
  {
    path: 'wallet',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: UserHomeComponent,
      },

      // "Otros destinos" (Vita). Su única entrada era el modal viejo de Enviar
      // Remesa; el cotizador unificado ya cotiza y envía esos rieles. Ruta
      // desactivada junto con el resto del flujo viejo.
      // {
      //   path: 'others-payouts',
      //   component: VitaCalculatorDemoComponent,
      //   canActivate: [OthersPayoutsGuard],
      // },

      // Clientes API (operadores): alta, configuracion, baja y revocacion de llaves
      // de la API de tasas. Hermano de `admin` y no hijo: ninguna ruta puede decir
      // «admin» (regla del dueno, 02/11). Mismo OperatorGuard, aplicado aca.
      {
        path: 'clientes-api-control',
        component: ClientesApiAdminComponent,
        canActivate: [OperatorGuard],
      },

      {
        path: 'admin',
        canActivateChild: [OperatorGuard],
        children: [
          // { path: 'main-rates', component: MainRatesComponent },
          { path: 'manual-xls-bci', component: ManualXlsBciComponent },
          // Tablero del programa de referidos: gasto, deuda retenida y quien trae.
          { path: 'referidos', component: ReferidosAdminComponent },
          // Panel de bonos: campanas, tablero de reclamos y reportes.
          // Va bajo `admin` con el guard de operador, como el de referidos.
          { path: 'bonos', component: BonosAdminComponent },
          // Links de campana: el link que se le entrega a Marketing y su embudo.
          { path: 'marketing-links', component: MarketingAdminComponent },
          // Recordatorio mensual a clientes que dejaron de operar.
          { path: 'recordatorio', component: RecordatorioAdminComponent },
          // Clientes API: alta, configuracion y baja de clientes de la API de tasas.
          // Movido a `wallet/clientes-api-control` (02/11): regla del dueno, ninguna
          // ruta puede decir «admin». Se deja comentada porque ya estaba commiteada.
          // { path: 'clientes-api', component: ClientesApiAdminComponent },
          // Seguimiento de clientes: el plan de retencion de la mesa USDT.
          // Cualquier operador entra; la cuenta tiene dueno para saber quien
          // responde, no para esconderle el tablero al resto.
          { path: 'seguimiento', component: SeguimientoComponent },
          { path: 'compliance-list', component: ComplianceListComponent },
          { path: 'compliance/:email', component: ComplianceUserComponent },
          { path: 'payer-compliance', component: PayerComplianceListComponent },
          {
            path: 'registro-beneficiarios',
            component: RegistroBeneficiariosComponent,
          },
          {
            path: 'data-update-requests',
            component: DataUpdateRequestsListComponent,
          },
          {
            // Importante: declarar la ruta de creación masiva ANTES
            // del catch-all `:id` para que `bulk/new` no se interprete
            // como un id de solicitud.
            path: 'data-update-requests/bulk/new',
            component: BulkCreateDataUpdateRequestComponent,
          },
          {
            path: 'data-update-requests/:id',
            component: DataUpdateRequestDetailComponent,
          },
          { path: 'working-account', component: WorkingAccountComponent },
          { path: 'active-accounts', component: AccountsComponent },
          { path: 'transactions', component: AdminTransactionsComponent },
          {
            path: 'completed-ves-transactions',
            component: TransactionsVesCompletedComponent,
          },
          {
            path: 'cbpay-view-list',
            component: CbpayViewWalletTransactionsComponent,
          },
          {
            path: 'pending-transactions',
            component: AssignedTransactionsComponent,
          },
          {
            path: 'balance-cbpay',
            component: CbpayCardexComponent,
          },
          {
            path: 'pending-transactions-binance',
            component: AssignedTransactionsComponent,
          },
          {
            path: 'pending-transactons-cripto',
            component: AssignedTransactionsCriptoComponent,
          },
          {
            path: 'unassigned-transaction',
            component: UnassignedTransactionsComponent,
          },
          {
            path: 'manual-transaction',
            component: ManualTransactionsComponent,
          },
          { path: 'modal', component: RejectTransactionModalComponent },
          {
            path: 'transaction-cashier',
            component: TransactionCashierComponent,
          },
          { path: 'balance-cajero', component: BalanceCajeroComponent },
          { path: 'status-cajero', component: StatusCajeroComponent },
          { path: 'status-cajero-fiat', component: StatusCajeroFiatComponent },
          { path: 'detalle-cajero', component: DetalleCajeroComponent },
          { path: 'cripto-rate', component: CriptoRateComponent },
          { path: 'zelle-rate', component: ZelleRateComponent },
          { path: 'hours-operations', component: HoursOperationsComponent },
          { path: 'wallets-usuarios', component: WalletsUsuariosComponent },
          {
            path: 'binance-link-subaccounts',
            component: BinanceLinkSubaccountsComponent,
          },
          {
            path: 'binance-centralizations',
            component: BinanceCentralizationsComponent,
          },
          { path: 'user-balance', component: UsersBalanceSearchComponent },
          {
            path: 'user-balance/:userId/:userEmail',
            component: UsersBalanceComponent,
          },
          // Creación directa OCULTA (no enlazada en UI): se conserva por compatibilidad.
          // Los pagadores ahora se crean por link (client/payer-invitations).
          { path: 'registerPayer', component: CreatePayerComponent },
          { path: 'billing-record', component: BillingRecordComponent },
          {
            path: 'cash-closing-report',
            component: GenerateCashClosingComponent,
          },
          {
            path: 'set-rates-parameters',
            component: SetRatesParametersComponent,
          },
          {
            path: 'set-rates-sales-parameters',
            component: SetRatesSalesParametersComponent,
          },
          {
            path: 'set-rates-parameters-bolivares',
            component: SetRatesParametersBolivaresComponent,
          },
          {
            path: 'comisiones-bancarias',
            component: ComisionesBancariasComponent,
          },
          {
            path: 'withdraw-transactions',
            component: WithdrawTrxListComponent,
          },
          {
            path: 'pending-transactions-zelle',
            component: PendingTransactionsZelleComponent,
          },
          {
            path: 'admin-wallets',
            component: AdminWalletsComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'admin-whatsapp-otp',
            component: AdminWhatsappOtpComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'dashboard-operation',
            component: TransactionsDashboardComponent,
          },
          // Historial unificado de operaciones: la lista paginada detras de los
          // contadores del tablero. Hereda el `OperatorGuard` del padre `admin`.
          {
            path: 'operations-history',
            component: OperationsHistoryComponent,
          },
          // Conciliacion de abonos: lo que entro a cada cuenta (CLP, VES, USDT)
          // y a quien se asigno. Hereda el `OperatorGuard` del padre `admin`.
          {
            path: 'conciliacion-abonos',
            component: ConciliacionAbonosComponent,
          },
          { path: 'user-segmentation', component: UserSegmentationComponent },
          {
            path: 'withdraw-transactions-sent',
            component: WithdrawTrxSentComponent,
          },
          {
            path: 'list-payer',
            component: ListPayerComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'list-pays-wallets-operator',
            component: ListPaysWalletsOperatorComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'wallets-conciliator',
            component: WalletsCardexConciliatorComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'wallets-usdt-clp-report',
            component: ReportUsdtClpGeneralComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'wallets-usdt-ves-report',
            component: ReportUsdtVesGeneralComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'transactions-ves',
            component: TransactionsVesComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'wallets-admin-send-usdt',
            component: AdminWithdrawalsUsdtComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'validar-wallet',
            component: ValidarWalletComponent,
          },
          {
            path: 'binance-search-by-wallet',
            component: BinanceSearchByWalletComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'responsable-wallet',
            component: ResponsableWalletComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'cuentas-activas-ves',
            component: CuentasActivasVesComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'bancos-activos-ves',
            component: BancosActivosVesComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'referencias-ves-admin',
            component: ReferenciasVesAdminComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'connected-users',
            component: ConnectedUsersComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'connection-history',
            component: ConnectionHistoryComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'connection-analytics',
            component: ConnectionAnalyticsComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'messages-inbox',
            component: PlatformMessagesInboxComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'messages-send',
            component: PlatformMessagesSendComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'n58',
            component: N58HomeComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'banco-plaza',
            component: BancoPlazaHomeComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'r4',
            component: R4HomeComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'vita-dashboard',
            component: VitaDashboardComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'vita-registro',
            component: VitaRegistroComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'vita-movimientos',
            component: VitaMovimientosComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'rail-colombia',
            component: RailColombiaComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'rail-peru',
            component: RailPeruComponent,
            canActivate: [AuthGuard],
          },
          // Calculadora Rail Colombia oculta temporalmente
          // {
          //   path: 'rail-colombia-calculadora',
          //   component: RailColombiaCalculadoraComponent,
          //   canActivate: [AuthGuard],
          // },
          {
            path: 'agent-chat',
            component: AgentChatComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'denounces',
            component: DenounceListComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'denounces/access',
            component: DenounceAccessManagerComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'denounces/:id',
            component: DenounceDetailComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'client',
        canActivateChild: [ClientGuard, DataUpdateBlockGuard],
        children: [
          // Formulario viejo de alta: sin OCR ni selfie y con PASAPORTE libre
          // (caso user 2358). Todo el que llegue acá va al registro nuevo.
          { path: 'user-validation', redirectTo: '/auth/signup' },
          { path: 'user-profile', component: UserProfileComponent },
          // Invita y gana: el usuario Aguacate y sus referidos.
          // Sólo con una campaña activa de su país: ver `ReferidosGuard`.
          { path: 'referidos', component: ReferidosComponent, canActivate: [ReferidosGuard] },
          // Bonos: escribir el codigo que salio en redes y ver los propios.
          { path: 'bonos', component: BonosComponent },
          {
            // Libreta única: un tab por país al que el perfil puede enviar.
            // `AccountRecipientComponent` sigue existiendo porque se usa
            // embebido (`single-money-order`), pero la ruta muestra la libreta
            // unificada.
            path: 'recipients',
            component: BeneficiaryBookComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'orders',
            component: TransactionsComponent,
            canActivate: [ActivateGuard],
          },
          // {
          //   path: 'single',
          //   component: SingleMoneyOrderComponent,
          //   canActivate: [ActivateGuard],
          // },
          // Misma pantalla vieja que `client/remittance` — desactivada por el
          // cotizador unificado.
          // {
          //   path: 'fiat',
          //   component: FiatCalculatorComponent,
          //   canActivate: [ActivateGuard],
          // },
          // { path: 'multiple', component: MultipleMoneyOrderComponent, canActivate: [ActivateGuard] },
          // Creación directa OCULTA (no enlazada en UI): se conserva por si luego
          // se habilita la creación manual por operador. El flujo actual es por link.
          // Con el guard: un cliente no habilitado no abre el formulario por URL.
          {
            path: 'registerPayer',
            component: CreatePayerComponent,
            canActivate: [ActivateGuard, CanAddPayersGuard],
          },
          {
            path: 'payerList',
            component: ListPayerComponent,
            canActivate: [ActivateGuard, CanAddPayersGuard],
          },
          {
            path: 'payer-invitations',
            component: PayerInvitationsComponent,
            canActivate: [ActivateGuard, CanAddPayersGuard],
          },
          {
            path: 'rechargeAccount',
            component: ChargeAccountComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'edit-payer/:payerId',
            component: CreatePayerComponent,
            canActivate: [ActivateGuard, CanAddPayersGuard],
          },
          {
            path: 'send-cripto',
            component: CalculatorCrytoComponent,
            canActivate: [ActivateGuard, OverdraftGuard],
          },
          {
            path: 'recipient-cripto',
            component: RecipientCriptoComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'recipient-zelle',
            component: RecipientZelleComponent,
            canActivate: [ActivateGuard],
          },
          {
            // La libreta internacional quedó absorbida por la libreta única
            // (`recipients`), que tiene un tab por país. La ruta redirige en vez
            // de morir: los links guardados siguen llegando a la libreta.
            path: 'recipient-internacional',
            redirectTo: 'recipients',
            pathMatch: 'full',
          },
          {
            path: 'cripto-home',
            component: CriptoHomeComponent,
            canActivate: [ActivateGuard],
          },
          // Pantalla vieja de remesa (`FiatCalculatorComponent`), reemplazada por
          // el cotizador unificado (`client/enviar`). Ruta desactivada: sin esto
          // la URL sigue abierta para quien la conozca o la tenga en favoritos.
          // {
          //   path: 'remittance',
          //   component: FiatCalculatorComponent,
          //   canActivate: [ActivateGuard, OverdraftGuard],
          // },
          {
            // Cotizador unificado: ÚNICA ruta de envío de remesas. Reemplaza al
            // modal viejo y a `client/remittance` / `client/fiat`, desactivadas
            // más abajo. Ya no hay allowlist — es el flujo para todos.
            path: 'enviar',
            component: RemittanceHubComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'withdraw-accounts',
            component: WithdrawAccountsComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'withdraw',
            component: WithdrawBalanceComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'withdraw-ves',
            component: WithdrawBalanceVesComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'zelle-home',
            component: ZelleHomeComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'send-zelle',
            component: CalculatorZelleComponent,
            canActivate: [ActivateGuard, OverdraftGuard],
          },
          {
            path: 'convert-usdt-clp',
            component: ConvertUsdtClpComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'convert-usdt-ves',
            component: ConvertUsdtVesComponent,
            canActivate: [ActivateGuard],
          },
          {
            // Seccion «API» del cliente: estado del acceso y documentacion.
            // El menu solo la muestra si `api-externa-cuenta/estado` lo habilita.
            path: 'api',
            component: ApiClienteComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'convert-ves-usdt',
            component: ConvertVesUsdtComponent,
            canActivate: [ActivateGuard],
          },
          {
            // Chileno con saldo VES: compra bolívares con su saldo CLP. El
            // componente devuelve al home a quien no es de la familia CL.
            path: 'comprar-bolivares',
            component: ComprarBolivaresComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'company-registration',
            component: CompanyRegistrationComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'load-pays-usdt',
            component: LoadPaysBinanceComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'send-usdt',
            component: SendUsdtComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'referencias-ves',
            component: ReferenciasVesComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'my-connections',
            component: MyConnectionsComponent,
            canActivate: [ActivateGuard],
          },
          {
            path: 'messages-inbox',
            component: PlatformMessagesInboxComponent,
          },
          // Ruta del formulario de actualización de datos. Sin
          // `ActivateGuard`: el cliente bloqueado por solicitud puede
          // (y debe) acceder aquí aunque esté en estado compliance
          // distinto al 3. El propio `DataUpdateBlockGuard` ya garantiza
          // que sólo se entra cuando hay solicitud asociada.
          {
            path: 'data-update-request/:id',
            component: DataUpdateRequestComponent,
          },
          // { path: 'edit-profile', component: EditUserDataComponent },
          //{ path: 'rates', component: AdminRateComponent },
          //{ path: 'day-rates', component: RatesComponent},
        ],
      },

      { path: '', redirectTo: 'home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
